import React, { useEffect, useState } from 'react'
import { AcountingHeading } from '../common/AcountingHeading'
import { Item } from '../../../common/snippets'
import { Box, Button, Checkbox, Collapse, FormControlLabel, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Datepicker from '../../../common/datePicker'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import moment from 'moment'
import DropDownOA from '../../../common/dropDownOA'
import { connect } from 'react-redux'
import { SplitButton } from '../../../common/SplitButton'
import { RefreshSvg } from '../../../common/svg/refresh'
import Lineinput from '../../../common/lineinput'
import * as url from '../../Reports/oldReportsUrls'
import { appendToUrl, calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth, clickElement, focusElemnt, generateDynamicColumnStyles, isEmpty, navigation1, navigation3 } from '../../../common/helper'
import { getBranchList, getCityList, getFtlBkngBranchList, updateAlertError } from '../../../../store/common/common_action'
import { FranchiseePendingToPayUpdateData, FranchiseeSettlementUpdateData, getCompanyListV2, getFranchiseeBranchList, getFranchiseePendingTopayRptData, getFranchiseeSettlementRptData } from '../../../../store/reports/reports_action'
import SuccessAndErrorModal from '../../../common/SuccessAndErrorModal'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { statusList } from '../FranchiseePendingTopayReport/constants'
import FrnSummaryTable from './FrnSummaryTable'
import FrnDetailedTbl from './FrnDetailedTbl'
import { getBranchAndCityList } from '../../../../store/generalSetting/GSAction'
import { viewReport } from '../common/AcountingConstants'
import { PostRequestCachedV3 } from '../../../common/api'
import { urls } from '../../../common/constants'
import { columnDefs, columnDefsExcel, headerColDefsExcel, summaryColDefs } from './Constants';
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { useTranslation } from '../../../../i18n/I18nProvider'
const FranchiseeSettlementReport = (props) => {
    const { translations } = useTranslation()
    const cs = translations?.common || {}
  const {
    data: { common, reports }, updateAlertError, getCompanyListV2, getBranchAndCityList, getFranchiseeBranchList, getFranchiseeSettlementRptData, FranchiseeSettlementUpdateData
  } = props
  const { franchiseeCompanyV2, reportCompanyV2, franchiseeBranches } = reports
  const { loginData, cityList, companySettings } = common
  const [filters, setFilters] = useState({ fromDate: moment(new Date()), toDate: moment(new Date()), fromCompany: '', fromBranch: '', franchisee: '', franchiseeBranch: '', status: statusList[0] })
  const [showTable, setShowTable] = useState(false)
  const reportName = 'Franchisee Settlement'
  const [selectAllLR, setSelectAllLR] = useState(false)
  const [selectedData, setSelectedData] = useState([])
  const [selectLr, setSelectLr] = useState('')
  const [isSuccess, setIsSuccess] = useState(false)
  const [fromCompanyList, setFromCompanyList] = useState([])
  const [originalFromBranch, setOriginalFromBranch] = useState([])
  const [fromBranchList, setFromBranchList] = useState([])
  const [franchiseeBranchList, setFranchiseeBranchList] = useState([])
  const [franchiseeCompanyList, setFranchiseeCompanyList] = useState([])
  const [tableData, setTableData] = useState([]);
  const [summaryData, setSummaryData] = useState([])
  const [originalData, setOriginalData] = useState([]);
  const [columns, setColumns] = useState([])
  const [excelColumns, setExcelColumns] = useState([])
  const [Table1, setTable1] = useState([])
const {intCompanyID} = loginData
  const [resetFilters, setResetFilters] = useState(false)
  const allownFormatLR = companySettings?.[0]?.UseFormattedLRinReports
  function addDaysToDate(date, days) {
    const newDate = new Date(date)
    newDate.setDate(newDate.getDate() + days)
    return newDate.toISOString().split('T')[0] // Returns the date in "YYYY-MM-DD" format
  }
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  useEffect(() => {
    focusElemnt('fromDate')
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const companylistBody = {
        intCompanyID: loginData?.intCompanyID,
        intUserID: loginData?.intUserID,
        intMode: 1,
      }
      getCompanyListV2(companylistBody, true, 24 * 60 * 60 * 1000)
      const franchiseelistBody = {
        intCompanyID: loginData?.intCompanyID,
        intUserID: loginData?.intUserID,
        intMode: 0,
      }
      getCompanyListV2(franchiseelistBody, false, 24 * 60 * 60 * 1000)

      let body = {
        intUserID: 0,
        intCompanyID: loginData?.intCompanyID,
        intBranchID: 0,
        strBranchName: "",
        strBranchCode: "",
        intStateID: 0,
        intCityID: 0,
        intIsActive: 1
      }
      PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, body, false, 24 * 60 * 60 * 1000).then((res) => {
        if (res.status === 'Success') {
          setOriginalFromBranch([...res?.Data?.Table])
          setFromBranchList([{ BranchName: 'All', BranchID: 0 }, ...res?.Data?.Table])
          setFilters((prev) => ({ ...prev, fromBranch: { BranchName: 'All', BranchID: 0 } }))
        }
      })
      const data = {
        intCompanyID: loginData.intCompanyID,
        intUserID: loginData.intUserID,
        intFranchiseeCompanyID: 0,
      }
      getFranchiseeBranchList(data)
    }
  }, [loginData])
  useEffect(() => {
    if (filters.fromCompany !== '') {
      const franchiseelistBody = {
        intCompanyID: filters?.fromCompany?.CompanyID,
        intUserID: loginData?.intUserID,
        intMode: 0,
      }
      getCompanyListV2(franchiseelistBody, false, 24 * 60 * 60 * 1000)

      let body = {
        intUserID: 0,
        intCompanyID:filters?.fromCompany?.CompanyID,
        intBranchID: 0,
        strBranchName: "",
        strBranchCode: "",
        intStateID: 0,
        intCityID: 0,
        intIsActive: 1
      }
      PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, body, false, 24 * 60 * 60 * 1000).then((res) => {
        if (res.status === 'Success') {
          let newList =  [{ BranchName: 'All', BranchID: 0 }, ...res?.Data?.Table]
          setFromBranchList(newList)
          setFilters((prev) => ({ ...prev, fromBranch: newList[0] }))
        }
      })
    }
  }, [filters.fromCompany])
  useEffect(() => {
    if (franchiseeCompanyV2?.length > 0) {
      let newList = franchiseeCompanyV2?.length > 1 ? [{ CompanyID: 0, CompanyName: 'All' }] : []
      newList?.push(franchiseeCompanyV2)
      setFranchiseeCompanyList(newList)
      setFilters((prev) => ({ ...prev, franchisee: newList[0] }))
    } else {
      setFranchiseeCompanyList([])
    }
  }, [franchiseeCompanyV2])
  useEffect(() => {
    if (filters?.franchisee !== '') {
      const data = {
        intCompanyID: filters?.fromCompany?.CompanyID === 0 ? loginData.intCompanyID : filters?.fromCompany?.CompanyID,
        intUserID: loginData.intUserID,
        intFranchiseeCompanyID: filters?.franchisee?.CompanyID,
      }
      getFranchiseeBranchList(data)
    }
  }, [filters?.franchisee, filters?.fromCompany])
  useEffect(() => {
    let newData = []
    if (reportCompanyV2?.length > 0) {
      newData = [{ CompanyID: 0, CompanyName: 'All' }, ...reportCompanyV2]
      setFromCompanyList(newData)
      setFilters((prev) => ({ ...prev, fromCompany: newData[0] }))
    } else {
      setFromCompanyList([])
      setFilters((prev) => ({ ...prev, fromCompany: '' }))
    }
  }, [reportCompanyV2])
  useEffect(() => {
    let newData = []
    if (franchiseeCompanyV2?.length > 0) {
      newData = [{ CompanyID: 0, CompanyName: 'All' }, ...franchiseeCompanyV2]
      setFranchiseeCompanyList(newData)
      setFilters((prev) => ({ ...prev, franchisee: newData[0] }))
    } else {
      setFranchiseeCompanyList([])
      setFilters((prev) => ({ ...prev, franchisee: '' }))
    }
  }, [franchiseeCompanyV2])
  useEffect(() => {
    if (filters?.franchisee !== '') {
      const data = {
        intCompanyID: loginData.intCompanyID,
        intUserID: loginData.intUserID,
        intFranchiseeCompanyID: filters?.franchisee?.CompanyID,
      }
      getFranchiseeBranchList(data)
    }
  }, [filters?.franchisee])
  useEffect(() => {
    if (franchiseeBranches?.length > 0) {
      let newData = [{ BranchID: 0, BranchName: 'All' }, ...franchiseeBranches]
      setFranchiseeBranchList(newData)
      setFilters((prev) => ({
        ...prev,
        franchiseeBranch: newData[0]
      }))
    }
  }, [franchiseeBranches])
    useEffect(()=>{
      if(allownFormatLR===1||allownFormatLR===0){
        setColumns(columnDefs)
        setExcelColumns(columnDefsExcel)
      }else if(allownFormatLR===2){
        let newCols = [...columnDefs]
        let newExcelCols = [...columnDefsExcel]
        newCols[1].header='Formatted LR'
        newCols[1].dataKey='FormattedLRNO'
        setColumns(newCols)
        newExcelCols[1].header = 'Formatted LR'
        newExcelCols[1].dataKey = 'FormattedLRNO'
        setExcelColumns(newExcelCols)
      }else if(allownFormatLR===3){
        let newCols = [...columnDefs]
        const newObject = { header: 'Formatted LRNO', dataKey: 'FormattedLRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '9%', textAlign: 'left' } }
        newCols.splice(2, 0, newObject);
        setColumns(newCols);
        let newExcelCols = [...columnDefsExcel]
        const newExcelObject =  { header: 'Formatted LRNO', dataKey: 'FormattedLRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 131.11} }
        newExcelCols.splice(2, 0, newExcelObject);
        setExcelColumns(newExcelCols);
      }
    },[allownFormatLR, columnDefs])
  const groupData = (data) => {
    const groupedData = {};
    const intCompanyID = loginData?.intCompanyID;

    // Group data by CompanyID and ChallanNo
    data.forEach(item => {
      const key = `${item.CompanyID}-${item.ChallanNo}`;

      if (!groupedData[key]) {
        let GroupByColumn = '';
        if (item.VehicleCompanyID === intCompanyID) {
          GroupByColumn = "Receivable From " + (item.CompanyID === intCompanyID ? item.DestinationCompanyName : item.CompanyName);
        } else {
          GroupByColumn = "Payable To " + (item.CompanyID === intCompanyID ? item.DestinationCompanyName : item.CompanyName);
        }
        groupedData[key] = {
          isSubHeading: true,
          GeneratedDateTime: GroupByColumn,
          toPayData: []
        };
      }

      groupedData[key].toPayData.push(item);
    });

    const combinedData = {};
    Object.values(groupedData).forEach(group => {
      const generatedDateTime = group.GeneratedDateTime;

      if (!combinedData[generatedDateTime]) {
        combinedData[generatedDateTime] = {
          isSubHeading: true,
          GeneratedDateTime: generatedDateTime,
          toPayData: []
        };
      }

      combinedData[generatedDateTime].toPayData = combinedData[generatedDateTime].toPayData.concat(group.toPayData);
    });
    return Object.values(combinedData).map(group => {
      const totalRow = {
        isTotalRow: true,
        GeneratedDateTime: 'Total',
        PaidItems: group.toPayData.reduce((sum, row) => sum + parseInt(row.PaidItems, 10), 0),
        TopayItems: group.toPayData.reduce((sum, row) => sum + parseInt(row.TopayItems, 10), 0),
        totalItems: group.toPayData.reduce((sum, row) => sum + parseInt(row.totalItems, 10), 0),
        PaidAmt: group.toPayData.reduce((sum, row) => sum + parseInt(row.PaidAmt, 10), 0),
        ActualTopayAmt: group.toPayData.reduce((sum, row) => sum + parseFloat(row.ActualTopayAmt), 0),
        ToPayComm: group.toPayData.reduce((sum, row) => sum + parseFloat(row.ToPayComm), 0),
        TopayAmt: group.toPayData.reduce((sum, row) => sum + parseFloat(row.TopayAmt), 0),
        totalAmt: group.toPayData.reduce((sum, row) => sum + parseFloat(row.totalAmt), 0),
        Charges: parseFloat(group.toPayData.reduce((sum, row) => sum + parseFloat(row.Charges), 0)).toFixed(2),
        NetPayable: parseFloat(group.toPayData.reduce((sum, row) => sum + parseFloat(row.NetPayable), 0)).toFixed(2)
      };

      group.toPayData.push(totalRow);
      return group;
    });
  };
  
  function convertToInt32(value) {
    const num = Number(value);
    if (!Number.isFinite(num)) throw new Error("Invalid input");

    const rounded = Math.round(num);
    const diff = Math.abs(num - rounded);

    if (diff === 0.5) {
        // Bankers' rounding: round to nearest even
        return (rounded % 2 === 0) ? rounded : rounded - Math.sign(num);
    }

    return rounded;
}
  const groupTables = (data) => {
    const groupedData = data.reduce((acc, row) => {
      const key = `${row.CompanyID}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(row);
      return acc;
    }, {});
    const mainData = Object.values(groupedData).map((list) => {
      const subGroup = list.reduce((acc, row) => {
        const key = `${row.ChallanNo}`;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(row);
        return acc;
      }, {});
      const listData = Object.values(subGroup).map((list) => {
        let obj = list.reduce((acc, curr) => {
          acc.PaidItems += parseInt(curr.PaidItems, 10) || 0;
          acc.TopayItems += parseInt(curr.TopayItems, 10) || 0;
          acc.totalItems += parseInt(curr.totalItems, 10) || 0;
          acc.PaidAmt += parseInt(curr.PaidAmt, 10) || 0;
          acc.ActualTopayAmt += parseFloat(curr.ActualTopayAmt) || 0;
          acc.TopayAmt += parseFloat(curr.TopayAmt) || 0;
          acc.ToPayComm += parseFloat(curr.ToPayComm) || 0;
          acc.totalAmt += parseFloat(curr.totalAmt) || 0;
          acc.Charges += parseFloat(curr.Charges) || 0;
          acc.NetPayable += parseFloat(curr.NetPayable) || 0;

          return acc;
        }, {
          ...list[0],
          PaidItems: 0, TopayItems: 0, totalItems: 0, PaidAmt: 0, ActualTopayAmt: 0, TopayAmt: 0, ToPayComm: 0, totalAmt: 0, Charges: 0, NetPayable: 0
        })
        return obj
      });
      return listData
    })
    const finalResult = groupData(mainData.flat())
    return finalResult
  };

  const handleClick1 = async () => {
    if (Math.abs(filters?.toDate.diff(filters?.fromDate, 'days'))>31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else if(filters?.fromCompany===''){
      updateAlertError({ show: true, msg: 'Please Select From Company', nextId: 'fromCompany' })
      return
    } else  if(filters?.fromBranch===''){
      updateAlertError({ show: true, msg: 'Please Select From Branch', nextId: 'fromBranch' })
      return
    } else  if(filters?.franchisee===''){
      updateAlertError({ show: true, msg: 'Please Select Franchisee', nextId: 'franchisee' })
      return
    } else  if(filters?.franchiseeBranch===''){
      updateAlertError({ show: true, msg: 'Please Select Franchisee Branch', nextId: 'franchiseeBranch' })
      return
    } else  if(filters?.status===''){
      updateAlertError({ show: true, msg: 'Please Select Status', nextId: 'status' })
      return
    } else{
    let body = {
      intCompanyID: filters?.fromCompany?.CompanyID,
      intBranchID: filters?.fromBranch?.BranchID,
      intFranchiseeCompanyID: filters?.franchisee?.CompanyID,
      intFranchiseeBranchID: filters?.franchiseeBranch?.BranchID,
      dtFromDate: moment(filters?.fromDate).format('YYYY-MM-DD'),
      dtToDate: moment(filters?.toDate).format('YYYY-MM-DD'),
      intStatus: filters?.status?.id,
      intUserID: loginData?.intUserID,
    }
    getFranchiseeSettlementRptData(body).then((res) => {
      if (res?.status === 'Success') {
        if (res?.Table?.length > 0) {
          const Table1 = [...res?.Table1]
          let intCompanyID = loginData?.intCompanyID
          setTable1(res?.Table1)
          const getSharingPercentage = (companyID, VehicleCompanyID) => {
            const sharingEntry = Table1.find(
              (entry) => entry.SendingCompanyID === companyID && Number(entry.ReceivingCompanyID) === VehicleCompanyID
            );
            return sharingEntry ? sharingEntry.SharingPercentage : 0; // Default to 0 if not found
          };

            let newData = res?.Table?.map((val) => {
              const totalAmt = Number(val.PaidAmt) + Number(val.ActualTopayAmt)
              let Charges = 0;
              let NetPayable = 0;

              return {
                ...val,
                GeneratedDateTime: val.GeneratedDateTime === '' || val.GeneratedDateTime === null || val.GeneratedDateTime === undefined ? '' : moment(val.GeneratedDateTime).format('DD-MMM-YYYY'),
                totalItems: Number(val.PaidItems) + Number(val?.TopayItems),
                receiveValue: Number(val.IsReceived) === 1 ? 'Paid' : 'UnPaid',
                receive:Number(val.IsReceived),
                remarks:val.Remarks,
                HasReceivedAtBranch: Number(val.HasReceivedAtBranch) === 1 ? 'Yes' : 'No',
                IsReceived:Number(val.IsReceived),
                Charges: Math.round(Charges), // Round to nearest integer
                NetPayable: Math.round(NetPayable), // Round to nearest integer
                totalAmt: Math.round(totalAmt) // Round to nearest integer
              };
            });
            setOriginalData(newData)
            let newGroupData = groupTables(newData);
            const newCombinedData = newGroupData?.map(group => {
              const updatedToPayData = group.toPayData?.map(row => {
                if (row.isTotalRow) return row; // We'll update this later
                const VehicleCompanyID = row.VehicleCompanyID;
                const CompanyID = row.CompanyID;
                const DestinationCompanyID = row.DestinationCompanyID;
                const TopayAmt = Number(row.TopayAmt) || 0;
                const PaidAmt = Number(row.PaidAmt) || 0;
                const ActualTopayAmt = Number(row.ActualTopayAmt) || 0;
                const finalSharingCommPer = ((100 - getSharingPercentage(CompanyID, VehicleCompanyID)) / 100);
                const totalAmt = PaidAmt + ActualTopayAmt;
                let Charges = 0;
                let NetPayable = 0;
            
                if (intCompanyID !== VehicleCompanyID && intCompanyID !== CompanyID && intCompanyID === DestinationCompanyID) {
                  Charges = Number(TopayAmt);
                  NetPayable = 0;
                } else if (intCompanyID !== VehicleCompanyID && intCompanyID === CompanyID && intCompanyID !== DestinationCompanyID) {
                  NetPayable = ((PaidAmt + ActualTopayAmt) * finalSharingCommPer) - PaidAmt;
                  Charges = NetPayable < 0 ? Math.abs(NetPayable) : 0;
                } else if (intCompanyID === VehicleCompanyID && intCompanyID !== CompanyID && intCompanyID !== DestinationCompanyID) {
                  Charges = Number((PaidAmt + ActualTopayAmt) * finalSharingCommPer).toFixed(1);
                  NetPayable = PaidAmt - Charges;
                } else if (intCompanyID === VehicleCompanyID && intCompanyID !== CompanyID && intCompanyID === DestinationCompanyID) {
                  Charges = Number(totalAmt * finalSharingCommPer).toFixed(1);
                  NetPayable = PaidAmt - convertToInt32(Charges);// Math.round(Charges)
                } else if (intCompanyID === VehicleCompanyID && intCompanyID === CompanyID && intCompanyID !== DestinationCompanyID) {
                  Charges = 0;
                  NetPayable = TopayAmt;
                }
             
                return {
                  ...row,
                  GeneratedDateTime: row.GeneratedDateTime ? moment(row.GeneratedDateTime).format('DD-MMM-YYYY') : '',
                  totalItems: Number(row.PaidItems) + Number(row.TopayItems),
                  receiveValue: Number(row.IsReceived) === 1 ? 'Paid' : 'UnPaid',
                  receive: Number(row.IsReceived),
                  remarks: row.Remarks,
                  HasReceivedAtBranch: Number(row.HasReceivedAtBranch) === 1 ? 'Yes' : 'No',
                  IsReceived: Number(row.IsReceived),
                  Charges: Number(Charges),
                  NetPayable: Math.round(NetPayable),
                  totalAmt: Math.round(totalAmt),
                };
              });
              const dataWithoutTotalRow = updatedToPayData.filter(row => !row.isTotalRow);
            
              let totalRow = {
                isTotalRow: true,
                GeneratedDateTime: 'Total',
                PaidItems: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.PaidItems) || 0), 0),
                TopayItems: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.TopayItems) || 0), 0),
                totalItems: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.totalItems) || 0), 0),
                PaidAmt: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.PaidAmt) || 0), 0),
                ActualTopayAmt: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.ActualTopayAmt) || 0), 0),
                ToPayComm: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.ToPayComm) || 0), 0),
                totalAmt: Math.round(dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.totalAmt) || 0), 0)),
                Charges:(dataWithoutTotalRow.reduce((acc, row) => Number(acc) + (Number(row.Charges) || 0), 0)).toFixed(1),
                NetPayable: Math.round(dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.NetPayable) || 0), 0)),
              };

              return {
                ...group,
                toPayData: [...dataWithoutTotalRow, totalRow]
              };
            });

            const subHeadingWithTotals = newCombinedData.map(group => ({
              GeneratedDateTime: group.GeneratedDateTime,
              NetPayable: group.toPayData.find(item => item.isTotalRow)?.NetPayable 
            }));
          const grandTotalNetPayable = subHeadingWithTotals.reduce(
            (acc, val) => acc + (Number(val.NetPayable) || 0), // Use Number to convert to a number, fallback to 0 if NaN
            0
          );

            // Create the total row
            const totalRow = {
              isTotalRow: true,
              GeneratedDateTime: 'Grand Total',
              NetPayable: grandTotalNetPayable
            };

            const updatedSubHeadingWithTotals = [...subHeadingWithTotals, totalRow];
            setSummaryData(updatedSubHeadingWithTotals);
            // setTableData(combinedData);
            setTableData(newCombinedData);

            setShowTable(true)
          }
          else {
            setTableData([])
            setShowTable(true)
          }
        } else {
          setTableData([])
          setShowTable(true)
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }

 const handleReset = () => {
     setFilters({ fromDate: moment(new Date()), toDate: moment(new Date()), fromCompany: '', fromBranch: '', franchisee: '', franchiseeBranch: '', status: statusList[0] })
     setShowTable(false)
     setTableData([])
     setSelectAllLR(false)
     setSelectedData([])
     setSelectLr('')
     setResetFilters(true)
     setTimeout(() => {
     setResetFilters(false)
     }, 0);
     // setIsSuccess(false)
   }
  const handleSelectAllLR = (e) => {
    let newData = [...tableData];
    const isChecked = e.target.checked;
    const intCompanyID = loginData?.intCompanyID
    let Count = 0
    newData.forEach((item) => {
      item.toPayData.forEach((row) => {
        if (!row.isTotalRow) {
          let condition = ((row.receiveValue == "Paid" || row.VehicleCompanyID != intCompanyID || row.HasReceivedAtBranch == 0) || (row.CompanyID == row.VehicleCompanyID && row.CompanyID == intCompanyID))
          if (!condition) {
            row.receive = isChecked ? 1 : 0;
            Count++;
          } else {
            row.receive = row?.IsReceived
          }
        }
      });
    });
    if (Count > 0) {
      setTableData(newData);
      setSelectAllLR(isChecked);

      if (isChecked) {
        // If checked, add all rows to selectedData
        const allRows = newData.flatMap(item => item.toPayData); // Flatten the toPayData arrays
        const newSelectedData = allRows.filter(row => !row.isTotalRow); // Assuming each row has a unique 'BookingID'
        setSelectedData(newSelectedData); // Set selectedData to all rows
      } else {
        // If unchecked, clear selectedData
        setSelectedData([]); // Clear selectedData
      }
    }
  }
  const handleUpdate = () => {
    if (selectedData?.length <= 0) {
      updateAlertError({ show: true, msg: 'Please Select Atleast One Row For Updating', nextId: '' })
      return
    } else {
      let body = {
        UserID: loginData?.intUserID,
        ChallanCompanyIDs: selectedData.map(row => row.CompanyID).join('^'),
        ChallanNos: selectedData.map(row => row.ChallanNo).join('^'),
        Remarks: selectedData.map(row => row.remarks).join('^'),
      }
      FranchiseeSettlementUpdateData(body).then((res) => {
        if (res.status === 'Success') {
          setIsSuccess(true)
        } else {
          updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
          return
        }
      }).catch((err) => {
        console.log('Error:', err)
      })
    }
  }
  const generatePDF = () => {
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const doc = new jsPDF({ orientation: 'l', format: [1680, 1187], unit: 'px', compress: true })

    doc.autoTableSetDefaults({
      headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
    })
    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(14)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left, pageHeight - 5, 'right')
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${loginData.strUserName} [ ${loginData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, doc.internal.pageSize.width / 2 -
        (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 + 90, pageHeight - 5
      )
    }
    doc.setProperties({
      title: `Franchisee Settlement Report.pdf`,
      subject: 'Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Franchisee Settlement Report',
      creator: 'MTLPL',
    })
    const HeaderData = [
      {
        fromCompany: filters?.fromCompany?.CompanyName,
        fromBranch: filters?.fromBranch?.BranchName,
        franchisee: filters?.franchisee?.CompanyName,
        franchiseeBranch: filters?.franchiseeBranch?.BranchName,
        status: filters?.status?.name,
      },
    ]
    const pdfHeaderCol = headerColDefsExcel?.filter((item) => item?.dataKey !== 'fromDate' && item?.dataKey !== 'toDate')
    const bodyData = tableData?.flatMap((item) => {
      if (item.isSubHeading) {
        // Modify the toPayData items and return the subheading item along with the modified toPayData
        const modifiedToPayData = item.toPayData.map((data) => ({
          ...data,
          IsReceived: data.IsReceived === 1 ? 'Yes' : data.IsReceived === 0 ? 'No' : '' // Change IsReceived property
        }));

        return [item, ...modifiedToPayData]; // Return the item and the modified toPayData
      }
    });
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 0 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: pdfHeaderCol,
      body: HeaderData,
      columnStyles: {
        0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        2: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        3: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        4: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
      },
      theme: 'grid',
      showHead: 'everyPage',
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: 14,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },
    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      startY: doc.lastAutoTable.finalY + 24,
      columns: excelColumns,
      body: bodyData,
      columnStyles: generateDynamicColumnStyles(excelColumns, 14),
      // showHead: 'repeat',
      theme: 'grid',
      styles: {
        fontSize: 14,
        lineWidth: [0, 0.6, 0, 0.6],
        fontStyle: 'bold',
      },
      tableLineWidth: 0.6,
      headStyles: {
        fontSize: 14,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'bold',
        font: 'Roboto',
      },
      didParseCell: (data) => {
        if (data.row.section === 'head' || data.row.section === 'body') {
          if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = 'right'
          } else {
            data.cell.styles.halign = 'left'
          }
        }
        if (data.row.raw.isSubHeading) {
          data.row.cells[0].colSpan = excelColumns?.length;
        }
      },
      willDrawCell: (data) => {
        if (data.row.raw.isSubHeading) {
          doc.setFillColor(218, 237, 254);
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(12).setFont("Roboto", 'normal')
          data.cell.styles.valign = 'middle';
          data.cell.colSpan = excelColumns?.length
        } else if (data.row.raw.isTotalRow) {
          doc.setFillColor(238, 238, 238);
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(12).setFont("Roboto", 'normal')
          data.cell.styles.valign = 'middle';
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(16)
        doc.setFont('Roboto', 'bold')
        doc.text(`Report Date : ${moment(filters?.fromDate).format('DD-MMM-YYYY')} To ${moment(filters?.toDate).format('DD-MMM-YYYY')}`, 30, 145)
        doc.setFontSize(16)
        doc.setFont('Roboto', 'bold')
        doc.text(`Report:Franchisee Settlement Report`, doc.internal.pageSize.width - data.settings.margin.left, 145, 'right')
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(20).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Accounting Reports', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(20).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 700, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      startY: doc.lastAutoTable.finalY + 24,
      columns: summaryColDefs,
      body: summaryData,
      columnStyles: {
        0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 188, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 188, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
      },
      // showHead: 'repeat',
      theme: 'grid',
      styles: {
        fontSize: 14,
        lineWidth: [0, 0.6, 0, 0.6],
        fontStyle: 'bold',
      },
      tableLineWidth: 0.6,
      headStyles: {
        fontSize: 14,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'bold',
        font: 'Roboto',
      },
      didParseCell: (data) => {
        if (data.row.section === 'head' || data.row.section === 'body') {
          if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = 'right'
          } else {
            data.cell.styles.halign = 'left'
          }
        }
      },
      willDrawCell: (data) => {
       if (data.row.raw.isTotalRow) {
          doc.setFillColor(238, 238, 238);
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(12).setFont("Roboto", 'normal')
          data.cell.styles.valign = 'middle';
        }
      },

    })
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    const pdfBlob = new Blob([doc.output('blob')], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    // Open the PDF in a new tab
    window.open(pdfUrl);
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <AcountingHeading reportName={reportName} />
      </Item>
      <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap' }}>
        <Item sx={{ ...sx.itemsx, width: '17%' }}>
          <DropDownOA
            id='company'
            label={'Select Company'}
            defaultvalue={loginData.strCompanyName}
            disabled={true}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
            GO
          </Button>
        </Item>
        <Item sx={{ ...sx.itemsx, width: '17%' }} className="input--container bookingDatePicker">
          <Datepicker
            label={`From Date`}
            id='fromDate'
            value={filters?.fromDate}
            dateChange={(date) => {
              setFilters((prev) => ({
                ...prev,
                fromDate: date
              }))
              setShowTable(false)
              focusElemnt('toDate')
            }}
            width={'100%'}
            startDate={'2022-01-01'}
            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '17%' }} className="input--container bookingDatePicker">
          <Datepicker
            label={'To Date'}
            id='toDate'
            value={filters?.toDate}
            dateChange={(date) => {
              setFilters((prev) => ({
                ...prev,
                toDate: date
              }))
              setShowTable(false)
              focusElemnt('fromCompany')
            }}
            width={'100%'}
            startDate={'2022-01-01'}
            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '17%' }}>
          <DropDownOA
            id={'fromCompany'}
            label={'From Company'}
            data={fromCompanyList || []}
            defaultvalue={filters?.fromCompany.CompanyName}
            idKey={`CompanyID`}
            dataKey={`CompanyName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                fromCompany: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Company`}
            width="100%"
            nextId={'fromBranch'}
            prevId={'toDate'}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '17%' }}>
          <DropDownOA
            id={'fromBranch'}
            label={'From Branch'}
            data={fromBranchList || []}
            defaultvalue={filters?.fromBranch?.BranchName}
            idKey={`BranchID`}
            dataKey={`BranchName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                fromBranch: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Branch`}
            width="100%"
            nextId={'franchisee'}
            prevId={'fromCompany'}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '17%' }}>
          <DropDownOA
            id={'franchisee'}
            label={'Franchisee'}
            data={franchiseeCompanyList || []}
            defaultvalue={filters?.franchisee?.CompanyName}
            idKey={`CompanyID`}
            dataKey={`CompanyName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                franchisee: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Franchisee`}
            width="100%"
            nextId={'franchiseeBranch'}
            prevId={'fromBranch'}
          />
        </Item>

      </Box>
      <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap', gap: '10px', width: '100%' }}>
        <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap', gap: '10px', width: '70%', paddingLeft: '0px', paddingTop: '0px' }}>
          <Item sx={{ ...sx.itemsx, width: '22%' }}>
            <DropDownOA
              id={'franchiseeBranch'}
              label={'Franchisee Branch'}
              data={franchiseeBranchList || []}
              defaultvalue={filters?.franchiseeBranch?.BranchName}
              idKey={`BranchID`}
              dataKey={`BranchName`}
              onSelect={(val) => {
                setFilters((prev) => ({
                  ...prev,
                  franchiseeBranch: val
                }))
                setShowTable(false)
              }}
              resetFlag={resetFilters}
              isObjArr={true}
              searchPlaceholder={`Search By Branch`}
              width="100%"
              nextId={'status'}
              prevId={'franchisee'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, width: '28%' }}>
            <DropDownOA
              id={'status'}
              label={'Status'}
              data={statusList || []}
              defaultvalue={filters?.status?.name}
              idKey={`id`}
              dataKey={`name`}
              onSelect={(val) => {
                setFilters((prev) => ({
                  ...prev,
                  status: val
                }))
                setShowTable(false)
              }}
              resetFlag={resetFilters}
              isObjArr={true}
              searchPlaceholder={`Search By Status`}
              width="100%"
              nextId={'splitButton'}
              prevId={'franchiseeBranch'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} 
            onKeyDown={(e) => navigation3(e, 'refreshBtn','status', () => handleClick1())}
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              hideToggle={true}
              id1={'splitButton'}
              onClick1={handleClick1}
              prevID={''}
            />
          </Item>
          <Item
            sx={{ ...sx.itemsx , padding:'5px 5px'}}
            id='refreshBtn'
            onKeyDown={(e) => navigation3(e, showTable?'excelBtn':'fromDate','splitButton', () => handleReset())}
            onClick={() => {
              handleReset()
            }}
          >
            <RefreshSvg />
          </Item>
        </Box>
       {showTable && <Box style={{ ...sx.reportFlex, width: '30%', flexWrap: 'nowrap', justifyContent: 'flex-end', paddingRight: '0px', paddingTop: '0px' }}>
          <Item sx={{ ...sx.itemsx, width: '47%', right: 0 }}>
            <FormControlLabel
              control={
                <Checkbox
                  id={`selectAll`}
                  checked={selectAllLR}
                  disabled={tableData?.length===0}
                  onChange={(e) => {
                    handleSelectAllLR(e)
                  }}
                  onKeyDown={(e) => {
                    navigation1(e, 'update_btn', 'refreshBtn')
                  }}
                />
              }
              label={'Select All Unpaid LRs'}
            />
          </Item>

          <Button
            variant="contained"
            onKeyDown={(e) => navigation3(e, 'excelBtn', 'selectAll', () => {handleUpdate() })}
            id={'update_btn'}
            sx={{ width: '100px', padding: '6px !important', fontSize: '14px !important' }}
            className="btn btn-primary"
            disabled={tableData?.length===0}
            onClick={() => {
              handleUpdate()
            }
            }
          > Update
          </Button>

        </Box>}
      </Box>
      <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap', padding: '10px 0px 0px 0px' }}>
        {showTable && <Box style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}>
          <h3 style={{ textAlign: 'left', color: '#444', paddingLeft: '22px' }}>Report For: Franchisee Settlement Report</h3>
        </Box>}
        <Box
          className='reportButton'
          style={{
            display: 'flex',
            width: '50%',
            justifyContent: 'end',
            alignItems: 'center',
            paddingRight: '22px',
            gap: '16px'
          }}
        >
          {showTable && (
            <>
              <Item sx={{ ...sx.itemsx }} className="">
                <Button
                  variant="outlined"
                  color="secondary"
                  id={'excelBtn'}
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                  onClick={(e) => {
                    e.preventDefault()
                    clickElement('xls-button-memo')
                  }}
                  onKeyDown={(e) => navigation1(e, 'print', 'memeoShortPrint')}
                >
                  Export To Excel
                </Button>
                <ReactHtmlTableToExcel
                  id="xls-button-memo"
                  table="delivery-memo-excel-tbl"
                  filename={'Franchisee Settlemnt Report'}
                  sheet="sheet 1"
                  buttonText="EXPORT AS EXCEL"
                  className="excel-button"
                />
              </Item>
              <Item sx={{ ...sx.itemsx }} className="">
                <Button id={"print"} variant="outlined" className="receiveitembtn"
                  onClick={() => { generatePDF() }}
                onKeyDown={(e) => {
                  navigation1(e, 'fromDate', 'excelBtn')
                }}
                >
                  Export To PDF
                </Button>
              </Item>
            </>)}
        </Box>
      </Box>
      {showTable && <FrnDetailedTbl selectedData={selectedData} setSelectedData={setSelectedData} tableData={tableData} setTableData={setTableData} loginData={loginData} originalData={originalData} groupTables={groupTables} 
      allownFormatLR={allownFormatLR} columns={columns} excelColumns={excelColumns} Table1={Table1} convertToInt32={convertToInt32}
      />}
      {showTable && <FrnSummaryTable tableData={summaryData} setTableData={setSummaryData} />}
      {/* -------------Table For Excel---------------- */}
      <TableContainer className='scrollBlue' component={Paper} style={{ marginBottom: '5px', maxHeight: '45vh' }}>
        <Table id='delivery-memo-excel-tbl' stickyHeader size="small" aria-label="a dense table" style={{ display: 'none' }} >
          <Table stickyHeader size="small" aria-label="a dense table" >
            <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={Math.floor(excelColumns?.length / 2)}
                >
                  <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '18px' }}>Franchisee Settlement Report</h3>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'right' }}
                  colSpan={Math.floor(excelColumns?.length / 2)}
                >
                  <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '18px' }}>Company Name : {loginData.strCompanyName}</h3>
                </TableCell>
              </TableRow>
              <TableRow ><TableCell colSpan={excelColumns?.length}></TableCell></TableRow>
              <TableRow >
                {headerColDefsExcel?.map((col, index) => (
                  <TableCell key={`CityHeader-${index}`}
                    colSpan={Math.floor(excelColumns?.length / headerColDefsExcel?.length)}
                    style={{
                      ...col.headerSx,
                      backgroundColor: '#DAEDFE',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444',
                      height: '36px',
                      whiteSpace: 'pre',
                      padding: '6px'
                    }}>
                    {col.header}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow >
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                  }}
                  colSpan={Math.floor(excelColumns?.length / headerColDefsExcel?.length)}
                >{moment(filters?.fromDate).format('DD-MMM-YY')}
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                  }}
                  colSpan={Math.floor(excelColumns?.length / headerColDefsExcel?.length)}
                >
                  {moment(filters?.toDate).format('DD-MMM-YY')}
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                  }}
                  colSpan={Math.floor(excelColumns?.length / headerColDefsExcel?.length)}
                >
                  {filters?.fromCompany?.CompanyName}
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                  }}
                  colSpan={Math.floor(excelColumns?.length / headerColDefsExcel?.length)}
                >
                  {filters?.fromBranch?.BranchName}
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                  }}
                  colSpan={Math.floor(excelColumns?.length / headerColDefsExcel?.length)}
                >
                  {filters?.franchisee?.CompanyName}
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                  }}
                  colSpan={Math.floor(excelColumns?.length / headerColDefsExcel?.length)}
                >
                  {filters?.franchiseeBranch?.BranchName}

                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                  }}
                  colSpan={Math.floor(excelColumns?.length / headerColDefsExcel?.length)}
                >
                  {filters?.status?.name}
                </TableCell>
              </TableRow>
              <TableRow ><TableCell colSpan={excelColumns?.length}></TableCell></TableRow>
              <TableRow>
                {excelColumns?.map((col, index) => (
                  <TableCell key={`CityHeader-${index}`} style={{
                    ...col.headerSx,
                    backgroundColor: '#DAEDFE',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#444',
                    height: '36px',
                    whiteSpace: 'pre',
                    padding: '6px'
                  }}>
                    {col.header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData?.length > 0 ?
              <TableBody>
                {tableData?.map((val, index) => (
                  <React.Fragment key={index}>
                    <TableRow>
                      <TableCell colSpan={excelColumns?.length} style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '98%' }}>{val.GeneratedDateTime}</TableCell>
                    </TableRow>
                    {val?.toPayData && (
                      val.toPayData.map((rowTwo, indexTwo) => (
                        rowTwo?.isTotalRow ?
                          <TableRow key={indexTwo}>
                            {/* <TableCell style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '2%' }}></TableCell> */}
                            <TableCell colSpan={4} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', minWidth: '100px' }}>{rowTwo.GeneratedDateTime}</TableCell>
                            <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.PaidItems}</TableCell>
                            <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.TopayItems}</TableCell>
                            <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.totalItems}</TableCell>
                            <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.PaidAmt}</TableCell>
                            <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.ActualTopayAmt}</TableCell>
                            <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.totalAmt}</TableCell>
                            <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.Charges}</TableCell>
                            <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.NetPayable}</TableCell>
                            <TableCell colSpan={10} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}></TableCell>
                          </TableRow> :
                          <TableRow key={indexTwo}>
                            {/* <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '2%' }}></TableCell> */}
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', minWidth: '100px' }}>{rowTwo.GeneratedDateTime}</TableCell>
                             {(allownFormatLR===0||allownFormatLR===1||allownFormatLR===3) && <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.LRNO}</TableCell>}
                                                                                {(allownFormatLR===2||allownFormatLR===3) && <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.FormattedLRNO}</TableCell>}
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.ChallanNo}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.BusNumber}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.BusCompanyName}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.PaidItems}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.TopayItems}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.totalItems}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.PaidAmt}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.ActualTopayAmt}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.totalAmt}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.Charges}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.NetPayable}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.FromCity}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.FromBranch}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.ToCity}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.ToBranch}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.receiveValue}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.receive === 1 ? 'Yes' : 'No'}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.HasReceivedAtBranch}</TableCell>
                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '10%' }}>{rowTwo?.Remarks} </TableCell>
                          </TableRow>
                      ))
                    )}
                  </React.Fragment>
                ))}
              </TableBody> :
              <TableBody>
                <TableRow>
                  <TableCell colSpan={columnDefs?.length + 1}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '20px',
                        marginBottom: '20px',
                        color: 'red',
                        fontSize: '14px',
                      }}
                    >
                      <span>No Results Found For The Selected Filters.</span>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            }
          </Table>
          <Table stickyHeader size="small" aria-label="a dense table">
            <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
              <TableRow>

                <TableCell colSpan={summaryColDefs?.length + 1}></TableCell>

              </TableRow>
              <TableRow>
                {summaryColDefs?.map((col, index) => (
                  <TableCell key={`CityHeader-${index}`} style={{
                    ...col.headerSx,
                    backgroundColor: '#DAEDFE',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#444',
                    height: '36px',
                    whiteSpace: 'pre',
                    padding: '6px'
                  }}>
                    {col.header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {summaryData?.length > 0 ?
              <TableBody>
                {summaryData?.map((val, index) => (
                  <TableRow>
                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '50%' }}>{val.GeneratedDateTime}</TableCell>
                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '50%', textAlign: 'right' }}>{val.NetPayable}</TableCell>
                  </TableRow>
                ))}
              </TableBody> :
              <TableBody>
                <TableRow>
                  <TableCell colSpan={summaryColDefs?.length + 1}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '20px',
                        marginBottom: '20px',
                        color: 'red',
                        fontSize: '14px',
                      }}
                    >
                      <span>No Results Found For The Selected Filters.</span>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            }
          </Table>
        </Table>

      </TableContainer >
      <SuccessAndErrorModal
        handleClose={() => {
          setIsSuccess(false);
          handleClick1()
        }} open={isSuccess} title={cs.updatedSuccessfully || 'Updated Successfully'} modalStyle={modalStyle} />
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateAlertError, getCompanyListV2, getBranchAndCityList, getFranchiseeBranchList, getFranchiseeSettlementRptData, FranchiseeSettlementUpdateData }
export default connect(mapStateToProps, mapDispatchToProps)(FranchiseeSettlementReport)
